export enum AgeGroup {
    KENYA_UNDER_18="Kenya: Under 18",
    KENYA_18_TO_69="Kenya: 18-69",
    KENYA_70_TO_75="Kenya: 70-75",
    KENYA_76_TO_80="Kenya: 76-80",
    KENYA_81_TO_85="Kenya: 81-85",
    KENYA_18_TO_85="Kenya: 18-85",

    RWANDA_LOW_RANGE="Rwanda: 5-40",
    RWANDA_MEDIUM_RANGE="Rwanda: 41-60",
    RWANDA_HIGH_RANGE="Rwanda: 61-70"
}